import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import PassengerType from 'components/ui/PassengerType';
import LoyaltyPointsInfos from 'components/shared/LoyaltyPointsInfos';
import { InfoGridHeaderCell, InfoGridCell } from '../SegmentInfo.styles';

const PaxInfo = ({ paxDetails, currency, isABSOrAdsAccessibleTravel = false }) => (
  <>
    <InfoGridHeaderCell>
      <FormattedMessage id="reviewScreen.tariffs" />:
    </InfoGridHeaderCell>
    <InfoGridHeaderCell>
      <FormattedMessage id="paymentsSummary.amount" />
    </InfoGridHeaderCell>
    <InfoGridHeaderCell>
      <FormattedMessage id="reviewScreen.passenger" />
    </InfoGridHeaderCell>
    <InfoGridHeaderCell>
      <FormattedMessage id="reviewScreen.pricePerPerson" />
    </InfoGridHeaderCell>
    {Object.keys(paxDetails).map((item) => (
      <Fragment key={item}>
        {paxDetails[item].map((obj) => (
          <Fragment key={`${item}-${obj.type}-${obj.disabilityType}`}>
            <InfoGridCell />
            <InfoGridCell data-testid={`count-${obj.count}-${obj.type}-${obj.disabilityType}`}>{obj.count}</InfoGridCell>
            <InfoGridCell>
              <PassengerType type={item} data-testid={`type-${obj.type}-${obj.disabilityType}`} />
              {obj.disabilityType !== 'NH' && obj.type !== 'DOG' && (
                <>
                  {' '}
                  <PassengerType
                    data-testid={`disability-type-${obj.type}-${obj.disabilityType}`}
                    type={obj.type}
                    disabilityType={obj.disabilityType}
                    isABSOrAdsAccessibleTravel={isABSOrAdsAccessibleTravel}
                  />
                </>
              )}
            </InfoGridCell>
            <InfoGridCell data-testid={`price-${obj.price}-${obj.type}-${obj.disabilityType}`}>
              <FormattedCurrency currency={currency} amount={obj.price || 0} />
              {!!obj.loyaltyPoints && <LoyaltyPointsInfos dataId="points-details" id="searchResults.pts" values={obj.loyaltyPoints} />}
            </InfoGridCell>
          </Fragment>
        ))}
      </Fragment>
    ))}
  </>
);

PaxInfo.propTypes = {
  currency: PropTypes.string,
  isABSOrAdsAccessibleTravel: PropTypes.bool,
  paxDetails: PropTypes.shape({
    disabilityType: PropTypes.string,
    price: PropTypes.number,
    count: PropTypes.string,
    loyaltyPoints: PropTypes.number,
    type: PropTypes.string
  })
};

export default PaxInfo;
